import React from 'react';
import logo from "../../images/svg/broker/shortlister-logo-wrap.svg";
import {BROKER, VENDOR} from "../../services/constants/CompanyType";
import NavLink from "../Navigation/NavLink";
const APP_URL = process.env.REACT_APP_APP_BASE_URL;

const Footer = ({accountType}) => {

    const footerMenu = [
        {
            href: 'https://www.myshortlister.com/terms-of-use',
            text: 'Terms of Use',
        },
        {
            href: 'https://www.myshortlister.com/privacy-policy-2',
            text: 'Privacy Policy',
        }
    ];

    switch (accountType) {
        case BROKER:
        case VENDOR:
            footerMenu.push({
                href: 'https://help.myshortlister.com/',
                text: 'Help & Support'
            });
            footerMenu.push({
                href: 'mailto:support@myshortlister.com',
                text: 'support@myshortlister.com',
            });
            break;
        default:
            break;
    }
    const currentYear = new Date().getFullYear();

    return (
        <footer className="sl-footer sl-flex sl-justify-center sl-bg-white sl-h-20 sl-px-12 sl-py-24"
                id="broker-footer">
            <div className="sl-container">
                <div className="sl-row sl-justify-center sl-items-center">
                    <a className="sl-col-span-2 sl-footer-logo" href={APP_URL}>
                        <img src={logo}
                             alt="Shortlister"
                             srcSet={logo}/>
                    </a>

                    <nav
                        className="sl-col-span-8 sl-flex sl-align-center sl-justify-center sl-navbar -sl-ml-5 -sl-mr-5">
                        <ul className="sl-p-0 sl-flex sl-gap-5 sl-align-center sl-justify-between">
                            {footerMenu.map((item, index) => (
                                <NavLink linkClass={"sl-mx-2 sl-text-gray-base sl-no-underline"} key={index}
                                         href={item.href} text={item.text} target={'_blank'} />
                            ))}
                        </ul>
                    </nav>

                    <span
                        className="sl-col-span-2 sl-copy sl-justify-self-end sl-font sl-font-medium sl-text-md sl-text-gray-400">© {currentYear} Shortlister </span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
